import { getDevices } from './api';

export function devicesQuery() {
  return {
    queryKey: ['devices'],
    queryFn: () => getDevices(),
    staleTime: 0,
  } as const;
}
